import React, { Component } from 'react';
import ReactTable from 'react-table';
import '../../../node_modules/react-table/react-table.css';
import { Link } from 'react-router-dom';
import Pagination from '../../components/pagination/pagination';
import { request } from '../../constants/constants';
import Loader from '../../components/loader/loader';
import Swal from 'sweetalert2';

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [
            ],
            pageSize: 10,
			currentPage: 1,
        }
    }


    handleThProps(state, rowInfo, column, instance) {
		return {
			onClick: (e) => {
				if (column.sortable !== false) {
					if (column.className !== 'header-checkbox-toggle') {
						instance.sortColumn(column)
					}
				}
			}
		}
	}

	handlePageChange(data) {
		this.setState({ currentPage: data + 1 });
	}

	handlePageSizeChange(data) {
		if (this.state.pageSize < data) {
			this.setState({ pageSize: data }, () => {
				// if (this.state.selectedAll[this.state.currentPage] === true) {
				// 	this.setState({
				// 		indeterminateSign: true
				// 	})
				// }
			});
		} else {
			this.setState({ pageSize: data }, () => {
				// const start = (this.state.currentPage - 1) * this.state.pageSize;
				// const end = start + this.state.pageSize;
				// let newSelected = {};
				// let newSelectPage;
				// if (this.state.selectedAll[this.state.currentPage] === true) {
				// 	newSelectPage = Object.assign(this.state.selectedAll, { [this.state.currentPage]: true });
				// 	this.state.teams.forEach(data => {
				// 		newSelected[data.id] = false;
				// 	});
				// 	this.state.teams.slice(start, end).forEach(data => {
				// 		newSelected[data.id] = true;
				// 	});
				// 	let newObj = Object.assign(this.state.selected, newSelected);
				// 	const selectedList = Object.keys(newObj).filter(obj => {
				// 		return newObj[obj] === true;
				// 	});
				// 	// this.props.selectedList(selectedList);
				// 	this.setState({
				// 		selected: newObj,
				// 		selectedAll: newSelectPage,
				// 		indeterminateSign: false
				// 	});
				// }
			});
        }
    }

    getAllUsers() {
        return request('GET', '/hq/users', {}, true);
    }

    handleDelete = (id, index) => e => {
        console.log(id);
        const users = this.state.users;
        const store = users[index];
        store.isLoading = true;
        this.setState({
            users
        })
        request('DELETE', `/hq/users/${id}`, {}, true).then(res => {
            store.isLoading = false;
            this.setState({
                users
            })
            console.log(res);
            this.init();
        }).catch(err => {
            console.error(err);
            store.isLoading = false;
            this.setState({
                users
            })
        })
    }
    
    
    init() {
        this.setState({
            isLoading: true
        })
        this.getAllUsers().then(res => {
            console.log(res);
            this.setState({
                users: res.data.data,
                isLoading: false
            })
        }).catch(err => {
            console.error(err);
            this.setState({
                isLoading: false
            })
        })
    }

    componentDidMount() {
        this.init()
    }   
    
    render() {
        const data = this.state.users;
		const columns = [
            {
                Header: 'Username',
                accessor: 'username',
                Cell: row => {
                    return (
                        <span className="highlight">{row.original.username}</span>
                    )
                }
            },
             {
                Header: 'Email',
                accessor: 'email',
                Cell: row => (
                    <span className="highlight">{row.original.email}</span>
                ),
            },
            {
                Header: 'Roles',
                accessor: 'roles',
                Cell: row => (
                  row.original.roles.map((role, i) => <span key={i} className="badge badge-info mr-2">{role}</span>)
                ),
            },
            {
                Header: 'Action',
                Cell: row => (
                    <React.Fragment>
                        <Link to={`/users/edit/${row.original.id}`} className="btn btn-success mr-2">
                          Edit
                        </Link> 
                        <button className="btn btn-danger">
                        {
                            row.original.isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : 'Delete'
                        }
                        </button>
                    </React.Fragment>
                ),
                width: 250
            },
        ];
        return (
           <div className="page-body">
            <div className="container-fluid">
                <div className="page-header">
                <div className="row">
                    <div className="col-lg-6">
                    <div className="page-header-left">
                        <h3>Users
                        {/* <small>Multikart Admin panel</small> */}
                        </h3>
                    </div>
                    </div>
                    <div className="col-lg-6">
                    <ol className="breadcrumb pull-right">
                        <li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg></Link></li>
                        <li className="breadcrumb-item active">Users</li>
                    </ol>
                    </div>
                </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                    <div className="card-header">
                        <h5>Manage Users</h5>
                    </div>
                    <div className="card-body order-datatable">
                        {/* <div className="btn-popup pull-right">
                           <Link to="/users/new"> <button type="button" className="btn btn-secondary">Add Store</button>  </Link>
                        </div> */}
                        <div className="table-responsive">
                           {
                               this.state.isLoading ? <Loader /> : (
                                <ReactTable
                                    PaginationComponent={Pagination}
                                    data={data}
                                    minRows={5}
                                    columns={columns}
                                    noDataText={this.state.isLoading ? '' : "No Stores Found."}
                                    defaultPageSize={this.state.pageSize}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    // resizable={true}
                                    onPageChange={(index) => this.handlePageChange(index)}
                                    onPageSizeChange={(size) => this.handlePageSizeChange(size)}
                                    getTheadThProps={(state, rowInfo, column, instance) => this.handleThProps(state, rowInfo, column, instance)}
                                 />
                               )
                           }
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>

        );
    }
}

export default Users;